/* tslint:disable:object-literal-sort-keys */

export const messages = {
    en: {
        auth: {
            login: {
                error: {
                    credentials: 'Your credentials are incorrect',
                    network: 'Communication with server failed'
                },
                form: {
                    password: { error: 'Please enter your User ID', label: 'Password' },
                    submit: 'Log in',
                    submitting: 'Logging in',
                    username: { error: 'Please enter your password', label: 'User ID' }
                }
            },
            renew: {
                slowNetwork: 'This is taking a bit longer than usual, please do not log out',
                spinner: 'We are getting you back online'
            }
        },
        dashboard: {
            movement: {
                title: 'Latest movements',
                emptyMessage: 'No movement to process'
            },
            task: { title: 'Latest tasks', emptyMessage: 'No task to process' }
        },
        entity: {
            actionMenu: {
                movement: {
                    addItem: 'Add object',
                    cancel: 'Cancel movement',
                    close: 'Finalize movement',
                    return: 'Create return movement'
                },
                noActions: 'No actions available',
                task: {
                    createComplexMovement: 'Create a complex movement',
                    createMovement: 'Create a movement from this task',
                    createSimpleMovement: 'Create a simple movement',
                    rejectTask: 'Reject the task',
                    startTask: 'Start the task'
                }
            },
            addItem: {
                error: {
                    api: 'The object could not be added',
                    network: 'Communication with server failed'
                },
                form: {
                    id: {
                        alreadyAdded: 'The object has already been added to this movement',
                        emptyError: 'Please scan an object',
                        label: 'Inventory number',
                        notFoundError: 'Object is unknown'
                    },
                    location: {
                        emptyError: 'Please select a location',
                        label: 'Arrival location',
                        notFoundError: 'Location is unknown'
                    },
                    submit: 'Add',
                    submitting: 'Adding'
                },
                modal: { title: 'Add object' }
            },
            cancelMovement: 'Do you want to cancel this movement?',
            closeMovement: {
                error: {
                    api: 'The movement could not be finalized',
                    network: 'Communication with server failed'
                },
                form: {
                    location: {
                        emptyError: 'Please select a location',
                        inputPlaceholder: 'Please type a location',
                        label: 'Arrival location',
                        noResult: 'No result',
                        notFoundError: 'Location unknown'
                    },
                    permanentLocation: { label: 'Use as permanent location' },
                    submit: 'Finalize',
                    submitting: 'Finalizing'
                },
                modal: {
                    cannotBeClosed: 'The movement current status does not allow for finalization',
                    noItems: 'You have not validated any object',
                    title: 'Finalize the movement'
                }
            },
            createMovementFromTask: 'Do you want to create a movement based on this task ?',
            createReturnMovement: 'Do you want to create a return movement from this movement?',
            noItems: 'No object is linked'
        },
        entityList: {
            actionMenu: { movement: { create: 'Create a movement' } },
            movement: {
                createMovement: 'Do you want to create a movement?',
                featuredEmptyMessage: 'No movement found',
                featuredTitle: 'Latest movements',
                field: {
                    author: 'Author',
                    endDate: 'End date',
                    startDate: 'Request',
                    title: 'Title'
                },
                historyTitle: 'Movements history'
            },
            task: {
                featuredEmptyMessage: 'No task found',
                featuredTitle: 'Latest tasks',
                field: {
                    author: 'Author',
                    endDate: 'End date',
                    startDate: 'Request',
                    title: 'Title'
                },
                historyTitle: 'Tasks history'
            }
        },
        firewall: {
            collabWarningMessage: "Your account doesn't any associated collaborator, the app may be disfunctionning",
            noGroupForUserWarningMessage: 'You user account needs to be part of group of users to be able to user SKINreporter'
        },
        featuredCard: {
            authorEmpty: 'No author',
            authorError: 'Impossible to retrieve the author',
            dateEmpty: 'No date available',
            descriptionEmpty: '-',
            headerDateEmpty: 'No date available',
            titleEmpty: '-'
        },
        itemCard: {
            detailsNotAvailable: 'Details not available',
            error: 'Object cannot be displayed',
            identifier: 'Inventory Number {identifier}',
            identifierError: 'Identification error',
            location: 'Location',
            locationLabel: 'Destination: <strong>{title}</strong>',
            rollback: 'Do you want to reset this object?',
            unknownLocation: 'Unknown',
            title: 'Title',
            locationSelector: { title: 'Select a location', validate: 'Choose this location' }
        },
        movement: {
            createModal: {
                form: {
                    motive: 'Reason of movement',
                    motiveMissing: 'Select reason of movement',
                    submit: 'Create movement',
                    submitting: 'Creating movement',
                    title: 'Title of movement',
                    titleMissing: 'Enter title of movement'
                },
                title: 'New movement'
            },
            entity: {
                associatedTask: 'Linked task:',
                empty: 'This movement does not have any linked objects'
            },
            featuredList: { emptyMessage: 'No movement available', title: 'Movements' },
            history: {
                emptyMessage: 'No saved movement',
                title: 'History of movements'
            },
            itemCard: {
                arrivalLocation: 'Arrival location',
                identifier: 'Inventory number',
                identifierError: 'Identification error',
                locationHint: 'Usual location',
                revertButton: 'Cancel',
                revertPrompt: 'Are you sure to reinitiate this object?',
                revertingButton: 'Cancelling',
                state: {
                    finalized: 'This object has been delivered',
                    inTransit: 'This object is in transit'
                }
            },
            state: {
                archived: 'Archived',
                canceled: 'Canceled',
                finalized: 'Completed',
                inPreparation: 'In preparation',
                inProgress: 'In progress',
                programmed: 'Planned'
            }
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Deployed on',
                checkForUpdate: {
                    help: 'If an update is available, it will automatically be installed',
                    title: 'Please check updates'
                },
                clearCache: {
                    help: 'If you are offline, it will block the access to all the data stored in the device',
                    title: 'Empty cache'
                },
                overrideLocale: {
                    help: 'English language will be used, overriding your device settings',
                    title: 'Override locale with ENGLISH'
                },
                resetLocaleOverride: {
                    help: 'Your device language settings will be used to set the application language',
                    title: 'Reset locale override'
                },
                title: 'Skin-REPORTER'
            },
            logout: 'Do you want to log out?'
        },
        offlineRibbon: { offline: 'You are now logged out' },
        proxy: {
            error: {
                default: 'An error occurred on the resource',
                network: 'Communication with server failed',
                notFound: 'Resource not found',
                tokenHasExpired: 'Session has expired'
            }
        },
        serviceWorker: {
            updateAvailable: 'An update has been installed. Please click here to refresh the page or restart the application'
        },
        task: {
            entity: {
                commentEditorPlaceholder: 'Type comments here...',
                comments: 'Comments',
                empty: 'There is no item associated to this task',
                hasPendingMovement: 'Movement creation in progress...'
            },
            featuredList: { emptyMessage: 'No task available', title: 'Tasks' },
            history: { emptyMessage: 'No archived tasks', title: 'Tasks history' },
            state: {
                finalized: 'Finalized',
                inProgress: 'In progress',
                planned: 'Planned'
            }
        },
        entityHistory: {
            field: {
                author: 'Author',
                date: 'Closing',
                description: 'Title',
                title: '#'
            }
        }
    },
    fr: {
        auth: {
            login: {
                error: {
                    credentials: 'Vos identifiants sont incorrects',
                    network: 'La communication avec le serveur a échoué'
                },
                form: {
                    password: {
                        error: "Veuillez saisir votre nom d'utilisateur",
                        label: 'Mot de passe'
                    },
                    submit: 'Se connecter',
                    submitting: 'Connexion...',
                    username: {
                        error: 'Veuillez saisir votre mot de passe',
                        label: "Nom d'utilisateur"
                    }
                }
            },
            renew: {
                slowNetwork: "Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.",
                spinner: 'Nous vous reconnectons...'
            }
        },
        dashboard: {
            movement: { title: 'Derniers mouvements', emptyMessage: 'Aucun mouvement' },
            task: { title: 'Dernières tâches', emptyMessage: 'Aucune tâche' }
        },
        entity: {
            actionMenu: {
                movement: {
                    addItem: 'Ajouter un objet',
                    cancel: 'Annuler le mouvement',
                    close: 'Clôturer le mouvement',
                    return: 'Créer un mouvement retour'
                },
                noActions: 'Aucune action possible',
                task: {
                    createComplexMovement: 'Créer un mouvement complexe',
                    createMovement: 'Créer un mouvement depuis cette tâche',
                    createSimpleMovement: 'Créer un mouvement simple',
                    rejectTask: 'Rejeter la tâche',
                    startTask: 'Démarrer la tâche'
                }
            },
            addItem: {
                error: {
                    api: "L'objet n'a pas pu être ajouté",
                    network: 'La communication avec le serveur a échoué'
                },
                form: {
                    id: {
                        alreadyAdded: "L'objet est déjà existant dans le mouvement",
                        emptyError: "Veuillez scanner un objet ou entrer son numéro d'inventaire",
                        label: "Numéro d'inventaire",
                        notFoundError: "L'objet est inconnu"
                    },
                    location: {
                        emptyError: 'Sélectionnez une localisation',
                        label: 'Destination d’arrivée',
                        notFoundError: 'La localisation est inconnue'
                    },
                    submit: 'Ajouter',
                    submitting: 'Ajout...'
                },
                modal: { title: 'Ajouter un objet' }
            },
            cancelMovement: 'Etes-vous sûr de vouloir annuler ce mouvement ?',
            closeMovement: {
                error: {
                    api: "Le mouvement n'a pas pu être clôturé",
                    network: 'La communication avec le serveur a échoué'
                },
                form: {
                    location: {
                        emptyError: 'Veuillez sélectionner une localisation',
                        inputPlaceholder: 'Entrez une localisation',
                        label: "Localisation d'arrivée",
                        noResult: 'Aucun résultat',
                        notFoundError: 'La localisation est inconnue'
                    },
                    permanentLocation: { label: 'Utiliser comme localisation permanente' },
                    submit: 'Clôturer',
                    submitting: 'Clôture...'
                },
                modal: {
                    cannotBeClosed: "Le mouvement n'est pas dans un état permettant d'être clôturé",
                    noItems: "Vous n'avez validé aucun objet",
                    title: 'Clôturer le mouvement'
                }
            },
            createMovementFromTask: 'Etes-vous sûr de vouloir créer un mouvement à partir de cette tâche ?',
            createReturnMovement: 'Etes-vous sûr de vouloir créer un mouvement retour à partir de ce mouvement ?',
            noItems: "Aucun objet n'est associé"
        },
        entityList: {
            actionMenu: { movement: { create: 'Créer un mouvement' } },
            movement: {
                createMovement: 'Etes-vous sûr de vouloir créer un mouvement ?',
                featuredEmptyMessage: 'Aucun mouvement',
                featuredTitle: 'Derniers mouvements',
                field: {
                    author: 'Auteur',
                    endDate: 'Date de fin',
                    startDate: 'Date de début',
                    title: 'Titre'
                },
                historyTitle: 'Historique des mouvements'
            },
            task: {
                featuredEmptyMessage: 'Aucune tâche',
                featuredTitle: 'Dernières tâches',
                field: {
                    author: 'Auteur',
                    endDate: 'Date de fin',
                    startDate: 'Date de début',
                    title: 'Titre'
                },
                historyTitle: 'Historique des tâches'
            }
        },
        firewall: {
            collabWarningMessage: "Votre compte n'a pas de collaborateur associé, l'application peut dysfonctionner",
            noGroupForUserWarningMessage: "L'usage de SKINreporter requiert que votre compte utilisateur soit lié à un groupe d'utilisateurs"
        },
        featuredCard: {
            authorEmpty: 'Aucun auteur',
            authorError: "Impossible de récuperer l'auteur",
            dateEmpty: 'Pas de date disponible',
            descriptionEmpty: '-',
            headerDateEmpty: 'Pas de date disponible',
            titleEmpty: '-'
        },
        itemCard: {
            detailsNotAvailable: 'Détails non disponible',
            error: "L'objet ne peut pas être affiché",
            identifier: 'N° Inv. {identifier}',
            identifierError: "Erreur d'identification",
            location: 'Localisation',
            locationLabel: 'Destination: <strong>{title}</strong>',
            rollback: 'Etes-vous sûr de vouloir réinitialiser cet objet ?',
            unknownLocation: 'Inconnue',
            title: 'Titre',
            locationSelector: {
                title: 'Sélectionner une localisation',
                validate: 'Choisir cette localisation'
            }
        },
        movement: {
            createModal: {
                form: {
                    motive: 'Motif',
                    motiveMissing: 'Vous devez sélectionner un motif',
                    submit: 'Créer le mouvement',
                    submitting: 'Création...',
                    title: 'Titre du mouvement',
                    titleMissing: 'Vous devez saisir un titre'
                },
                title: 'Nouveau mouvement'
            },
            entity: {
                associatedTask: 'Tâche associée :',
                empty: "Le mouvement ne contient pas d'objet"
            },
            featuredList: {
                emptyMessage: 'Aucun mouvement disponible',
                title: 'Mouvements'
            },
            history: {
                emptyMessage: 'Aucun movement archivé',
                title: 'Historique des mouvements'
            },
            itemCard: {
                arrivalLocation: "Localisation d'arrivée",
                identifier: "Numéro d'inventaire",
                identifierError: "Erreur d'identification",
                locationHint: 'Localisation habituelle',
                revertButton: 'Annuler',
                revertPrompt: 'Etes-vous sûr de vouloir réinitialiser cet objet ?',
                revertingButton: 'Annulation...',
                state: {
                    finalized: 'Cet objet est livré',
                    inTransit: 'Cet objet est en transit'
                }
            },
            state: {
                archived: 'Archivé',
                canceled: 'Annulé',
                finalized: 'Terminé',
                inPreparation: 'En préparation',
                inProgress: 'En cours',
                programmed: 'Planifié'
            }
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Déployé le',
                checkForUpdate: {
                    help: "Si une mise à jour est disponible, elle s'installera automatiquement.",
                    title: 'Vérifiez les mises à jour'
                },
                clearCache: {
                    help: "Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.",
                    title: 'Vider le cache'
                },
                overrideLocale: {
                    help: 'La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.',
                    title: 'Forcer la langue anglaise'
                },
                resetLocaleOverride: {
                    help: 'La langue utilisé dépendra du paramètrage de votre terminal',
                    title: 'Réinitialiser la langue'
                },
                title: 'Skin-REPORTER'
            },
            logout: 'Etes-vous sûr de vouloir vous déconnecter ?'
        },
        offlineRibbon: { offline: 'Vous êtes hors connexion' },
        proxy: {
            error: {
                default: "Une erreur s'est produite sur la resource {uri}",
                network: 'La communication avec le serveur a échoué',
                notFound: "La ressource {uri} n'a pas été trouvée",
                tokenHasExpired: 'Votre session a expiré'
            }
        },
        serviceWorker: {
            updateAvailable: "Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application"
        },
        task: {
            entity: {
                commentEditorPlaceholder: 'Saisissez un commentaire concernant cette tâche...',
                comments: 'Commentaires',
                empty: "La tâche ne contient pas d'objet",
                hasPendingMovement: 'Création du mouvement en cours...'
            },
            featuredList: { emptyMessage: 'Aucune tâche disponible', title: 'Tâches' },
            history: {
                emptyMessage: 'Aucune tâche archivée',
                title: 'Historique des tâches'
            },
            state: {
                finalized: 'Terminé',
                inProgress: 'En cours',
                planned: 'Planifié'
            }
        },
        entityHistory: {
            field: {
                author: 'Auteur',
                date: 'Clôture',
                description: 'Titre',
                title: '#'
            }
        }
    },
    "fr-ca": {
        countryCode: "ca",
        auth: {
            login: {
                error: {
                    credentials: 'Vos identifiants sont incorrects',
                    network: 'La communication avec le serveur a échoué'
                },
                form: {
                    password: {
                        error: "Veuillez saisir votre nom d'utilisateur",
                        label: 'Mot de passe'
                    },
                    submit: 'Se connecter',
                    submitting: 'Connexion...',
                    username: {
                        error: 'Veuillez saisir votre mot de passe',
                        label: "Nom d'utilisateur"
                    }
                }
            },
            renew: {
                slowNetwork: "Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.",
                spinner: 'Nous vous reconnectons...'
            }
        },
        dashboard: {
            movement: { title: 'Derniers mouvements', emptyMessage: 'Aucun mouvement' },
            task: { title: 'Dernières tâches', emptyMessage: 'Aucune tâche' }
        },
        entity: {
            actionMenu: {
                movement: {
                    addItem: 'Ajouter un objet',
                    cancel: 'Annuler le mouvement',
                    close: 'Clôturer le mouvement',
                    return: 'Créer un mouvement retour'
                },
                noActions: 'Aucune action possible',
                task: {
                    createComplexMovement: 'Créer un mouvement complexe',
                    createMovement: 'Créer un mouvement depuis cette tâche',
                    createSimpleMovement: 'Créer un mouvement simple',
                    rejectTask: 'Rejeter la tâche',
                    startTask: 'Démarrer la tâche'
                }
            },
            addItem: {
                error: {
                    api: "L'objet n'a pas pu être ajouté",
                    network: 'La communication avec le serveur a échoué'
                },
                form: {
                    id: {
                        alreadyAdded: "L'objet est déjà existant dans le mouvement",
                        emptyError: "Veuillez scanner un objet ou entrer son numéro d'inventaire",
                        label: "Numéro d'inventaire",
                        notFoundError: "L'objet est inconnu"
                    },
                    location: {
                        emptyError: 'Sélectionnez une localisation',
                        label: 'Destination d’arrivée',
                        notFoundError: 'La localisation est inconnue'
                    },
                    submit: 'Ajouter',
                    submitting: 'Ajout...'
                },
                modal: { title: 'Ajouter un objet' }
            },
            cancelMovement: 'Etes-vous sûr de vouloir annuler ce mouvement ?',
            closeMovement: {
                error: {
                    api: "Le mouvement n'a pas pu être clôturé",
                    network: 'La communication avec le serveur a échoué'
                },
                form: {
                    location: {
                        emptyError: 'Veuillez sélectionner une localisation',
                        inputPlaceholder: "Entrez une localisation",
                        label: "Localisation d'arrivée",
                        noResult: "Aucun résultat",
                        notFoundError: 'La localisation est inconnue'
                    },
                    permanentLocation: { label: 'Utiliser comme localisation permanente' },
                    submit: 'Clôturer',
                    submitting: 'Clôture...'
                },
                modal: {
                    cannotBeClosed: "Le mouvement n'est pas dans un état permettant d'être clôturé",
                    noItems: "Vous n'avez validé aucun objet",
                    title: 'Clôturer le mouvement'
                }
            },
            createMovementFromTask: 'Etes-vous sûr de vouloir créer un mouvement à partir de cette tâche ?',
            createReturnMovement: 'Etes-vous sûr de vouloir créer un mouvement retour à partir de ce mouvement ?',
            noItems: "Aucun objet n'est associé"
        },
        entityList: {
            actionMenu: { movement: { create: 'Créer un mouvement' } },
            movement: {
                createMovement: 'Etes-vous sûr de vouloir créer un mouvement ?',
                featuredEmptyMessage: 'Aucun mouvement',
                featuredTitle: 'Derniers mouvements',
                field: {
                    author: 'Auteur',
                    endDate: 'Date de fin',
                    startDate: 'Date de début',
                    title: 'Titre'
                },
                historyTitle: 'Historique des mouvements'
            },
            task: {
                featuredEmptyMessage: 'Aucune tâche',
                featuredTitle: 'Dernières tâches',
                field: {
                    author: 'Auteur',
                    endDate: 'Date de fin',
                    startDate: 'Date de début',
                    title: 'Titre'
                },
                historyTitle: 'Historique des tâches'
            }
        },
        firewall: {
            collabWarningMessage: "Votre compte n'a pas de collaborateur associé, l'application peut dysfonctionner",
            noGroupForUserWarningMessage: "L'usage de SKINreporter requiert que votre compte utilisateur soit lié à un groupe d'utilisateurs"
        },
        featuredCard: {
            authorEmpty: 'Aucun auteur',
            authorError: "Impossible de récuperer l'auteur",
            dateEmpty: 'Pas de date disponible',
            descriptionEmpty: '-',
            headerDateEmpty: 'Pas de date disponible',
            titleEmpty: '-'
        },
        itemCard: {
            detailsNotAvailable: 'Détails non disponible',
            error: "L'objet ne peut pas être affiché",
            identifier: 'N° Inv. {identifier}',
            identifierError: "Erreur d'identification",
            location: 'Localisation',
            locationLabel: 'Destination: <strong>{title}</strong>',
            rollback: 'Etes-vous sûr de vouloir réinitialiser cet objet ?',
            unknownLocation: 'Inconnue',
            title: 'Titre',
            locationSelector: {
                title: "Sélectionner une localisation",
                validate: "Choisir cette localisation"
            }
        },
        movement: {
            createModal: {
                form: {
                    motive: 'Motif',
                    motiveMissing: 'Vous devez sélectionner un motif',
                    submit: 'Créer le mouvement',
                    submitting: 'Création...',
                    title: 'Titre du mouvement',
                    titleMissing: 'Vous devez saisir un titre'
                },
                title: 'Nouveau mouvement'
            },
            entity: {
                associatedTask: 'Tâche associée :',
                empty: "Le mouvement ne contient pas d'objet"
            },
            featuredList: {
                emptyMessage: 'Aucun mouvement disponible',
                title: 'Mouvements'
            },
            history: {
                emptyMessage: 'Aucun movement archivé',
                title: 'Historique des mouvements'
            },
            itemCard: {
                arrivalLocation: "Localisation d'arrivée",
                identifier: "Numéro d'inventaire",
                identifierError: "Erreur d'identification",
                locationHint: 'Localisation habituelle',
                revertButton: 'Annuler',
                revertPrompt: 'Etes-vous sûr de vouloir réinitialiser cet objet ?',
                revertingButton: 'Annulation...',
                state: {
                    finalized: 'Cet objet est livré',
                    inTransit: 'Cet objet est en transit',
                }
            },
            state: {
                archived: 'Archivé',
                canceled: 'Annulé',
                finalized: 'Terminé',
                inPreparation: 'En préparation',
                inProgress: 'En cours',
                programmed: 'Planifié'
            }
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Déployé le',
                checkForUpdate: {
                    help: "Si une mise à jour est disponible, elle s'installera automatiquement.",
                    title: 'Vérifiez les mises à jour'
                },
                clearCache: {
                    help: "Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.",
                    title: 'Vider le cache'
                },
                overrideLocale: {
                    help: 'La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.',
                    title: 'Forcer la langue anglaise'
                },
                resetLocaleOverride: {
                    help: 'La langue utilisé dépendra du paramètrage de votre terminal',
                    title: 'Réinitialiser la langue'
                },
                title: 'Skin-REPORTER'
            },
            logout: 'Etes-vous sûr de vouloir vous déconnecter ?'
        },
        offlineRibbon: { offline: 'Vous êtes hors connexion' },
        proxy: {
            error: {
                default: "Une erreur s'est produite sur la resource {uri}",
                network: 'La communication avec le serveur a échoué',
                notFound: "La ressource {uri} n'a pas été trouvée",
                tokenHasExpired: 'Votre session a expiré'
            }
        },
        serviceWorker: {
            updateAvailable: "Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application"
        },
        task: {
            entity: {
                commentEditorPlaceholder: 'Saisissez un commentaire concernant cette tâche...',
                comments: 'Commentaires',
                empty: "La tâche ne contient pas d'objet",
                hasPendingMovement: 'Création du mouvement en cours...'
            },
            featuredList: { emptyMessage: 'Aucune tâche disponible', title: 'Tâches' },
            history: {
                emptyMessage: 'Aucune tâche archivée',
                title: 'Historique des tâches'
            },
            state: {
                finalized: 'Terminé',
                inProgress: 'En cours',
                planned: 'Planifié'
            }
        },
        entityHistory: {
            field: {
                author: 'Auteur',
                date: 'Clôture',
                description: 'Titre',
                title: '#'
            }
        }
    },
    nl: {
        auth: {
            login: {
                error: {
                    credentials: 'Uw legitimatie is niet correct',
                    network: 'Communicatie met server mislukt'
                },
                form: {
                    password: {
                        error: 'Gelieve uw gebruikersnaam in te voeren',
                        label: 'Paswoord'
                    },
                    submit: 'Inloggen',
                    submitting: 'Aan het inloggen…',
                    username: {
                        error: 'Gelieve uw paswoord in te voeren',
                        label: 'Gebruikersnaam'
                    }
                }
            },
            renew: {
                slowNetwork: 'Dit duurt langer dan gebruikelijk, gelieve niet uit te loggen',
                spinner: 'We brengen u terug online'
            }
        },
        dashboard: {
            movement: {
                title: 'Laatste verplaatsingen',
                emptyMessage: 'Geen verplaatsing om te verwerken'
            },
            task: {
                title: 'Laatste taken',
                emptyMessage: 'Geen taak om te verwerken'
            }
        },
        entity: {
            actionMenu: {
                movement: {
                    addItem: 'Voeg object toe',
                    cancel: 'Annuleer verplaatsing',
                    close: 'Beëindig verplaatsing',
                    return: 'Maak terugkeerverplaatsing aan'
                },
                noActions: 'Geen acties beschikbaar',
                task: {
                    createComplexMovement: 'Maak een complexe verplaatsing aan',
                    createMovement: 'Maak een verplaatsing aan vanuit deze taak',
                    createSimpleMovement: 'Maak een eenvoudige verplaatsing aan',
                    rejectTask: 'Keur taak af',
                    startTask: 'Start taak'
                }
            },
            addItem: {
                error: {
                    api: 'Het object kon niet worden toegevoegd',
                    network: 'Communicatie met server mislukt'
                },
                form: {
                    id: {
                        alreadyAdded: 'Het object werd reeds toegevoegd aan deze verplaatsing',
                        emptyError: 'Gelieve een object te scannen',
                        label: 'Inventarisnummer',
                        notFoundError: 'Object niet gekend'
                    },
                    location: {
                        emptyError: 'Gelieve een locatie te selecteren',
                        label: 'Aankomstlocatie',
                        notFoundError: 'Locatie niet gekend'
                    },
                    submit: 'Voeg toe',
                    submitting: 'Aan het toevoegen…'
                },
                modal: { title: 'Voeg object toe' }
            },
            cancelMovement: 'Wenst u deze verplaatsing te annuleren?',
            closeMovement: {
                error: {
                    api: 'De verplaatsing kon niet worden beëindigd',
                    network: 'Communicatie met server mislukt'
                },
                form: {
                    location: {
                        emptyError: 'Gelieve een locatie te selecteren',
                        inputPlaceholder: 'Gelieve een locatie in te typen',
                        label: 'Aankomstlocatie',
                        noResult: 'Geen resultaat',
                        notFoundError: 'Locatie niet gekend'
                    },
                    permanentLocation: { label: 'Gebruik als permanente locatie' },
                    submit: 'Beëindigen',
                    submitting: 'Aan het beëindigen'
                },
                modal: {
                    cannotBeClosed: 'De huidige status van de verplaatsing laat geen beëindiging toe',
                    noItems: 'U heeft geen enkel object gevalideerd',
                    title: 'Beëindig verplaatsing'
                }
            },
            createMovementFromTask: 'Wenst u een verplaatsing aan te maken op basis van deze taak?',
            createReturnMovement: 'Wenst u een terugverplaatsing aan te maken vanuit deze verplaatsing?',
            noItems: 'Geen gerelateerd object '
        },
        entityList: {
            actionMenu: { movement: { create: 'Maak een verplaatsing aan' } },
            movement: {
                createMovement: 'Wenst u een verplaatsing aan te maken?',
                featuredEmptyMessage: 'Geen verplaatsing gevonden',
                featuredTitle: 'Laatste verplaatsingen',
                field: {
                    author: 'Auteur',
                    endDate: 'Einddatum',
                    startDate: 'Verzoek',
                    title: 'Titel'
                },
                historyTitle: 'Historiek van de verplaatsingen'
            },
            task: {
                featuredEmptyMessage: 'Geen taak gevonden',
                featuredTitle: 'Laatste taken',
                field: {
                    author: 'Auteur',
                    endDate: 'Einddatum',
                    startDate: 'Verzoek',
                    title: 'Titel'
                },
                historyTitle: 'Historiek van de taken'
            }
        },
        firewall: {
            collabWarningMessage: 'MISSING TRANSLATION',
            noGroupForUserWarningMessage: 'MISSING TRANSLATION'
        },
        featuredCard: {
            authorEmpty: 'Geen auteur',
            authorError: 'Onmogelijk om auteur terug te vinden',
            dateEmpty: 'Geen datum beschikbaar',
            descriptionEmpty: '-',
            headerDateEmpty: 'Geen datum beschikbaar',
            titleEmpty: '-'
        },
        itemCard: {
            detailsNotAvailable: 'Geen details beschikbaar',
            error: 'Object kan niet worden weergegeven',
            identifier: 'Inventarisnummer {identifier}',
            identifierError: 'Identificatie-error',
            location: 'Locatie',
            locationLabel: 'Bestemming: <strong>{title}</strong>',
            rollback: 'Wenst u dit object te resetten?',
            unknownLocation: 'Ongekend',

            title: 'MISSING TRANSLATION',
            locationSelector: { title: 'Selecteer een locatie', validate: 'Kies deze locatie' }
        },
        movement: {
            createModal: {
                form: {
                    motive: 'Reden van de verplaatsing',
                    motiveMissing: 'Selecteer reden van de verplaatsing',
                    submit: 'Maak verplaatsing aan',
                    submitting: 'Verplaatsing aan het aanmaken…',
                    title: 'Titel van de verplaatsing',
                    titleMissing: 'Voer titel van de verplaatsing in'
                },
                title: 'Nieuwe verplaatsing'
            },
            entity: {
                associatedTask: 'Gerelateerde taak:',
                empty: 'Deze verplaatsing heeft geen gerelateerde objecten'
            },
            featuredList: {
                emptyMessage: 'Geen verplaatsing beschikbaar',
                title: 'Verplaatsingen'
            },
            history: {
                emptyMessage: 'Geen bewaarde verplaatsing',
                title: 'Historiek van de verplaatsingen'
            },
            itemCard: {
                arrivalLocation: 'Aankomstlocatie',
                identifier: 'Inventarisnummer',
                identifierError: 'Identificatie-error',
                locationHint: 'Gebruikelijke locatie',
                revertButton: 'Annuleer',
                revertPrompt: 'Bent u zeker dat u dit object opnieuw wenst op te starten?',
                revertingButton: 'Annuleren…',
                state: {
                    finalized: 'Dit object werd afgeleverd',
                    inTransit: 'Dit object is in transit'
                }
            },
            state: {
                archived: 'Gearchiveerd',
                canceled: 'Geannuleerd',
                finalized: 'Beëindigd',
                inPreparation: 'In voorbereiding',
                inProgress: 'In verwerking',
                programmed: 'Gepland'
            }
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Ingezet op/Ontwikkeld op',
                checkForUpdate: {
                    help: 'Als een update beschikbaar is, zal die automatisch worden geïnstalleerd.',
                    title: 'Gelieve te controleren op updates'
                },
                clearCache: {
                    help: 'Als u offline bent, heeft u niet langer toegang tot alle gegevens die op uw toestel zijn opgeslagen.',
                    title: 'Cache (tijdelijk geheugen) leegmaken'
                },
                overrideLocale: {
                    help: 'Het Engels zal worden gebruikt en de instellingen van uw apparaat zullen worden genegeerd.',
                    title: 'Het ENGELS forceren'
                },
                resetLocaleOverride: {
                    help: 'De taalinstellingen van uw apparaat zullen worden gebruikt om de taal van de toepassing in te stellen',
                    title: 'Reset forcering van de taal'
                },
                title: 'Skin-REPORTER'
            },
            logout: 'Wenst u uit te loggen?'
        },
        offlineRibbon: { offline: 'U bent nu uitgelogd' },
        proxy: {
            error: {
                default: 'Error bij de hulpbron',
                network: 'Communicatie met server mislukt',
                notFound: 'Hulpbron niet gevonden',
                tokenHasExpired: 'Sessie is verlopen'
            }
        },
        serviceWorker: {
            updateAvailable: 'Er werd een update geïnstalleerd. Gelieve hier te klikken om te pagina te vernieuwe of de toepassing te herstarten'
        },
        task: {
            entity: {
                commentEditorPlaceholder: 'Voer hier opmerkingen in…',
                comments: 'Opmerkingen',
                empty: 'Er geen item gerelateerd aan deze taak',
                hasPendingMovement: 'Aanmaken van verplaatsing in verwerking…'
            },
            featuredList: { emptyMessage: 'Geen taak beschikbaar', title: 'Taken' },
            history: {
                emptyMessage: 'Geen gearchiveerde taken',
                title: 'Historiek van de taken'
            },
            state: {
                finalized: 'Beëindigd',
                inProgress: 'In verwerking',
                planned: 'Gepland'
            }
        },
        entityHistory: {
            field: {
                author: 'Auteur',
                date: 'Aan het afsluiten',
                description: 'Titel',
                title: '#'
            }
        }
    },
    es: {
        auth: {
            login: {
                error: {
                    credentials: 'Sus datos de acceso son incorrectos',
                    network: 'La comunicación con el servidor ha fallado'
                },
                form: {
                    password: {
                        error: 'Por favor, introduzca su nombre de usuario',
                        label: 'Contraseña'
                    },
                    submit: 'Entrar en el sistema',
                    submitting: 'Conectando...',
                    username: {
                        error: 'Por favor, introduzca su contraseña',
                        label: 'Nombre de usuario'
                    }
                }
            },
            renew: {
                slowNetwork: 'Si parece que tarda más de lo habitual, no abandones la aplicación.',
                spinner: 'Le reconectamos...'
            }
        },
        dashboard: {
            movement: {
                title: 'Últimos movimientos',
                emptyMessage: 'No hay movimiento'
            },
            task: { title: 'Últimas tareas', emptyMessage: 'No hay tareas' }
        },
        entity: {
            actionMenu: {
                movement: {
                    addItem: 'Añadir un objeto',
                    cancel: 'Anular el movimiento',
                    close: 'Cerrar el movimiento',
                    return: 'Crear un movimiento de retorno'
                },
                noActions: 'No hay acción posible',
                task: {
                    createComplexMovement: 'Crear un movimiento complejo',
                    createMovement: 'Crear una transacción a partir de esta tarea',
                    createSimpleMovement: 'Crear un movimiento sencillo',
                    rejectTask: 'Rechazar la tarea',
                    startTask: 'Iniciar la tarea'
                }
            },
            addItem: {
                error: {
                    api: 'No se ha podido añadir el objeto',
                    network: 'La comunicación con el servidor ha fallado'
                },
                form: {
                    id: {
                        alreadyAdded: 'El objeto ya existe en el movimiento',
                        emptyError: 'Por favor, escanee un artículo o introduzca su número de inventario',
                        label: 'Número de inventario',
                        notFoundError: 'El objeto es desconocido'
                    },
                    location: {
                        emptyError: 'Seleccione una ubicación',
                        label: 'Destino de la llegada',
                        notFoundError: 'La ubicación es desconocida'
                    },
                    submit: 'Añadir',
                    submitting: 'Añadiendo...'
                },
                modal: { title: 'Añadir un objeto' }
            },
            cancelMovement: '¿Está seguro de que quiere cancelar este movimiento?',
            closeMovement: {
                error: {
                    api: 'La transacción no pudo cerrarse',
                    network: 'La comunicación con el servidor ha fallado'
                },
                form: {
                    location: {
                        emptyError: 'Seleccione una ubicación',
                        inputPlaceholder: 'Introduzca una ubicación',
                        label: 'Lugar de llegada',
                        noResult: 'No hay resultados',
                        notFoundError: 'La ubicación es desconocida'
                    },
                    permanentLocation: { label: 'Utilizar como lugar permanente' },
                    submit: 'Cerrar',
                    submitting: 'Cerrando...'
                },
                modal: {
                    cannotBeClosed: 'La transacción no está en estado de ser cerrada',
                    noItems: 'No ha liberado ningún objeto',
                    title: 'Cerrar el movimiento'
                }
            },
            createMovementFromTask: '¿Está seguro de que quiere crear un movimiento a partir de esta tarea?',
            createReturnMovement: '¿Está seguro de que quiere crear un movimiento de retorno a partir de este movimiento?',
            noItems: 'No hay objeto asociado'
        },
        entityList: {
            actionMenu: { movement: { create: 'Crear un movimiento' } },
            movement: {
                createMovement: '¿Está seguro de que quiere crear un movimiento?',
                featuredEmptyMessage: 'No hay movimiento',
                featuredTitle: 'Últimos movimientos',
                field: {
                    author: 'Autor',
                    endDate: 'Fecha de finalización',
                    startDate: 'Fecha de inicio',
                    title: 'Título'
                },
                historyTitle: 'Historia del movimiento'
            },
            task: {
                featuredEmptyMessage: 'No hay tarea',
                featuredTitle: 'Últimas tareas',
                field: {
                    author: 'Autor',
                    endDate: 'Fecha de finalización',
                    startDate: 'Fecha de inicio',
                    title: 'Título'
                },
                historyTitle: 'Historial de tareas'
            }
        },
        firewall: {
            collabWarningMessage: 'Su cuenta no tiene un colaborador asociado, la aplicación puede funcionar mal',
            noGroupForUserWarningMessage: 'El uso de SKINreporter requiere que su cuenta de usuario esté vinculada a un grupo de usuarios'
        },
        featuredCard: {
            authorEmpty: 'Sin autor',
            authorError: 'Imposible recuperar al autor',
            dateEmpty: 'No hay fecha disponible',
            descriptionEmpty: '-',
            headerDateEmpty: 'No hay fecha disponible',
            titleEmpty: '-'
        },
        itemCard: {
            detailsNotAvailable: 'Detalles no disponibles',
            error: 'El objeto no se puede mostrar',
            identifier: 'Nº de inventario {identificar}',
            identifierError: 'Identificación errónea',
            location: 'Ubicación',
            locationLabel: 'Destino: <strong>{title}</strong>',
            rollback: '¿Está seguro de que quiere restablecer este elemento?',
            unknownLocation: 'Desconocido',
            title: 'Título',
            locationSelector: {
                title: 'Seleccione una ubicación',
                validate: 'Elija esta ubicación'
            }
        },
        movement: {
            createModal: {
                form: {
                    motive: 'Motivo',
                    motiveMissing: 'Debe seleccionar un motivo',
                    submit: 'Crear el movimiento',
                    submitting: 'Creación...',
                    title: 'Título del movimiento',
                    titleMissing: 'Debe introducir un título'
                },
                title: 'Nuevo movimiento'
            },
            entity: {
                associatedTask: 'Tarea relacionada:',
                empty: 'La transacción no contiene un objeto'
            },
            featuredList: {
                emptyMessage: 'No hay movimientos disponibles',
                title: 'Movimientos'
            },
            history: {
                emptyMessage: 'No hay movimientos archivados',
                title: 'Historia del movimiento'
            },
            itemCard: {
                arrivalLocation: 'Lugar de llegada',
                identifier: 'Número de inventario',
                identifierError: 'Identificación errónea',
                locationHint: 'Ubicación habitual',
                revertButton: 'Cancelar',
                revertPrompt: '¿Está seguro de que quiere restablecer este elemento?',
                revertingButton: 'Cancelación...',
                state: {
                    finalized: 'Este objeto está entregado',
                    inTransit: 'Este objeto está en tránsito'
                }
            },
            state: {
                archived: 'Archivado',
                canceled: 'Cancelado',
                finalized: 'Completado',
                inPreparation: 'En preparación',
                inProgress: 'En curso',
                programmed: 'Planificado'
            }
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Desplegado en',
                checkForUpdate: {
                    help: 'Si hay una actualización disponible, se instalará automáticamente.',
                    title: 'Comprobar las actualizaciones'
                },
                clearCache: {
                    help: 'Si está sin conexión, esto elimina el acceso a todos los datos almacenados en el dispositivo.',
                    title: 'Vaciar la caché'
                },
                overrideLocale: {
                    help: 'Se utilizará el idioma inglés y se ignorará la configuración de su terminal.',
                    title: 'Forzar el idioma inglés'
                },
                resetLocaleOverride: {
                    help: 'El idioma utilizado dependerá de la configuración de su terminal',
                    title: 'Restablecer el idioma'
                },
                title: 'Skin-REPORTER'
            },
            logout: '¿Está seguro de que quiere desconectarse?'
        },
        offlineRibbon: { offline: 'Usted está fuera de línea' },
        proxy: {
            error: {
                default: 'Se ha producido un error en el recurso {uri}',
                network: 'La comunicación con el servidor ha fallado',
                notFound: 'No se ha encontrado el recurso {uri}',
                tokenHasExpired: 'Su sesión ha expirado'
            }
        },
        serviceWorker: {
            updateAvailable: 'Se ha instalado una actualización. Pulse aquí para recargar la página o reiniciar la aplicación'
        },
        task: {
            entity: {
                commentEditorPlaceholder: 'Introduzca un comentario sobre esta tarea...',
                comments: 'Comentarios',
                empty: 'La tarea no contiene un objeto',
                hasPendingMovement: 'Creación del movimiento actual...'
            },
            featuredList: { emptyMessage: 'No hay tareas disponibles', title: 'Tareas' },
            history: {
                emptyMessage: 'No hay tareas archivadas',
                title: 'Historial de tareas'
            },
            state: {
                finalized: 'Completado',
                inProgress: 'En curso',
                planned: 'Planificado'
            }
        },
        entityHistory: {
            field: {
                author: 'Autor',
                date: 'Cierre',
                description: 'Título',
                title: '#'
            }
        }
    }
};

export const dateTimeFormats = {
    fr: {
        short: {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        },
        shortTime: {
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric',
            month: '2-digit',
            second: 'numeric',
            year: 'numeric',
        },
        year: {
            year: 'numeric',
        },
    },
};
